export default {
  enableMaterialRede: true,
  customButtonPages: [2],
  showBannerPages: [],
  underListPages: [],
  tabelaMateriaisPage: null,
  ensureCurrentItemQuantity: true,
  modelProcesso: {
    id_unidade_destino: null,
    id_setor_destino: null,
  },
  currentMaterialModelProcesso: {},
  pageList: [
    {
      title: 'Informações da transferência',
      subItems: [{ title: 'Destino dos materiais' }],
    },
  ],
};
